// Local design tokens for the Studio Settings overlay. Mirrors the user's
// mockup `SET` color object, kept colocated with the overlay (same approach
// as `chord-practice/palette.ts` for the editorial direction). The values
// align with `welcome-studio-card` / `empty-studio-overlay` / `piece-overview`
// neighbours so the overlay reads as a sibling of those screens.

export const SET = {
  // Surfaces
  bg: "rgba(7, 7, 9, 0.92)",
  surface: "rgba(255, 255, 255, 0.03)",
  surfaceHi: "rgba(255, 255, 255, 0.05)",
  border: "rgba(255, 255, 255, 0.06)",
  borderHi: "rgba(255, 255, 255, 0.12)",

  // Text
  text: "#e8e8ed",
  textDim: "#a1a1aa",
  textMute: "#7a7a85",
  textVeryMute: "#4a4a55",

  // Brand
  violet: "#8b5cf6",
  violetLight: "#c4b5fd",
  violetSoft: "rgba(139, 92, 246, 0.14)",
  violetGlow: "rgba(139, 92, 246, 0.32)",

  // Status
  green: "#34d399",
  greenGlow: "rgba(52, 211, 153, 0.45)",
  amber: "#fbbf24",
  red: "#f87171",
};

export const FONT_MONO =
  "var(--font-geist-mono), 'JetBrains Mono', ui-monospace, monospace";

export const FONT_SERIF = "var(--font-fraunces), 'Fraunces', serif";
